
export default function FourPillars() {
  const pillars = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'Mentorship Training & Capacity Building',
      description: 'Structured learning programs and continuous skill development to help you grow from beginner to expert',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Discipline, Regimentation & Stoicism',
      description: 'Building mental toughness, consistency, and the mindset required for long-term success',
    },
    {
      icon: 'ri-heart-add-line',
      title: 'Health Optimization',
      description: 'Through nutrition, supplementation & lifestyle changes to create real wellness solutions',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Leverage & Financial Systems',
      description: 'Deeper understanding of building sustainable income streams that grow beyond personal effort',
    },
  ];

  return (
    <section className="py-20 bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            The Four Fundamental Pillars
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-stone-200"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-500 rounded-full mb-6">
                <i className={`${pillar.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                {pillar.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
